import React from "react";
import { Outlet } from "react-router-dom";
import PartnerOnlyRoute from "../auth/PartnerOnlyRoute";
import "./PartnerToolsShell.css";

/** Guard + shared page shell for every /partner/tools/* page. */
const PartnerToolsRoot = () => (
  <PartnerOnlyRoute>
    <div className="partner-tools-shell">
      <Outlet />
    </div>
  </PartnerOnlyRoute>
);

export default PartnerToolsRoot;
